import { RefObject, useEffect, useState } from 'react';

export interface UseScrollState {
  x: number;
  y: number;
}

let ticking = false;
const initialState = { x: 0, y: 0 };

function useScroll(ref: RefObject<HTMLElement>): UseScrollState {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setState(
            ref.current
              ? {
                  x: ref.current.scrollLeft,
                  y: ref.current.scrollTop,
                }
              : initialState,
          );
          ticking = false;
        });
      }

      ticking = true;
    }

    ref.current?.addEventListener('scroll', handleScroll);

    return () => {
      ref.current?.removeEventListener('scroll', handleScroll);
    };
  }, [ref.current]);

  return state;
}

export default useScroll;
